module.exports = __webpack_public_path__ + "img/carrusel-2.712f96ad.png";